// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1c177daa","952":"ad45062a"}[chunkId] + ".chunk.js";
};